import { faBirthdayCake, faChampagneGlasses, faGift, faHeart, faSnowflake } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Toolbar from "components/Toolbar";
import dayjs from "dayjs";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { apiGet } from "utils/apiFetch";
import pathObj from "utils/apiPath";

function GiftCardsHistory() {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [sentGiftCards, setSentGiftCards] = useState([]);
  const [page, setPage] = useState(1);
  const [canLoadMore, setCanLoadMore] = useState(false);

  const getSentGiftCards = async () => {
    setLoading(true);
    try {
      const path = pathObj.sentGiftCards;
      const result = await apiGet(path, { page, page_size: 10 });

      setSentGiftCards([...sentGiftCards, ...result.data.results.docs]);
      setCanLoadMore(result.data.results.hasNextPage);
    } catch (error) {
    }
    setLoading(false);
  };

  const handleScroll = useCallback(() => {
    const bottom = window.innerHeight + window.scrollY > document.body.scrollHeight - 5;
    if (bottom && !loading && canLoadMore) {
      setPage((prev) => prev + 1);
    }
  }, [loading, canLoadMore]);

  useEffect(() => {
    getSentGiftCards();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  const getCardIcon = (type) => {
    switch (type) {
      case "Christmas":
        return faSnowflake;
      case "Birthday":
        return faBirthdayCake;
      case "Congratulations":
        return faChampagneGlasses;
      case "Anniversary":
        return faHeart;
      default:
        return faGift;
    }
  };

  useEffect(() => {
    // clean up code
    window.removeEventListener("scroll", handleScroll);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  return (
    <>
      <Toolbar title={t("NAV_GIFT_CARD")} showBackBtn={true} />
      <div className="flex flex-col w-full justify-center items-center">
        <div className="w-full md:w-[25rem] mt-3 p-4 overflow-y-auto">
          <div className="flex justify-start w-full px-2">
            <div className="text-lg font-medium">{t("GIFT_CARD_SEND")}</div>
          </div>

          {sentGiftCards.map((it) => (
            <div key={it._id} className="bg-card p-4 flex justify-start items-center gap-3 mt-3 cursor-pointer">
              <FontAwesomeIcon icon={getCardIcon(it.title)} size="xl" className="text-white" />
              <div className="flex justify-between items-center w-full">
                <div className="flex flex-col">
                  <span className="font-medium text-white">{it.message}</span>
                  <span className="text-white font-medium">{it.receiver_email}</span>
                </div>
                <span className="text-white font-medium">{dayjs(it.delivery_date).format("DD/MM/YYYY")}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default GiftCardsHistory;
